"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealmDisplay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var realms_engine_browser_1 = require("realms-engine-browser");
var realms_three_1 = __importDefault(require("realms-three"));
var RealmDisplay = function (_a) {
    var width = _a.width, height = _a.height, createRealm = _a.createRealm, _b = _a.fov, fov = _b === void 0 ? 75 : _b;
    var realmRef = (0, react_1.useRef)(null);
    var canvasRef = (0, react_1.useRef)(null);
    var cameraRef = (0, react_1.useRef)(new realms_three_1.default.PerspectiveCamera(fov !== null && fov !== void 0 ? fov : 45, width / height, 0.1, 1000));
    // Initialises and updates realm
    (0, react_1.useEffect)(function () {
        if (realmRef.current) {
            var renderSystem = realmRef.current.systems.getSafely(realms_engine_browser_1.Render3DSystem);
            renderSystem === null || renderSystem === void 0 ? void 0 : renderSystem.updateSize({ width: width, height: height });
            return;
        }
        // Create realm
        if (!realmRef.current && canvasRef.current) {
            realmRef.current = createRealm({
                camera: cameraRef.current,
                canvas: canvasRef.current,
            });
        }
    }, [createRealm, height, width]);
    // Starts a realm
    (0, react_1.useEffect)(function () {
        var realm = realmRef.current;
        if (!realm) {
            return;
        }
        var realmRunner = new realms_engine_browser_1.BrowserRealmRunner(realm);
        realmRunner.run();
        return function () {
            realm.clean();
            realmRunner.end();
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)("canvas", { ref: canvasRef, width: width, height: height, style: {
            width: "".concat(width, "px"),
            height: "".concat(height, "px"),
        } }));
};
exports.RealmDisplay = RealmDisplay;
